var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "analise" },
    [
      _c("h3", { staticClass: "titulo-cadastar-foto" }, [
        _vm._v("Vincular fotos a cadastros Reurb")
      ]),
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("filtro", {
            attrs: { configuracaoFiltro: _vm.configuracaoFiltro },
            on: { pesquisar: _vm.pesquisar, limpar: _vm.clearFiltro }
          })
        ],
        1
      ),
      _c("app-listagem", {
        attrs: {
          "has-refresh-button": true,
          showButtonOrdemServico: false,
          showButtonAssinatura: false,
          "has-expansivel": false,
          "json-headers": _vm.colunas,
          "json-data": _vm.items,
          totalElements: _vm.totalElements,
          pagina: _vm.filtro.pagina,
          hasFiltroRapido: true,
          filtro: _vm.filtro
        },
        on: {
          atualizarFiltro: _vm.atualizarFiltro,
          updateListagem: _vm.refresh,
          changePage: _vm.changePage,
          sort: _vm.sort,
          executar: _vm.executar
        }
      }),
      _vm.showModalVisualizarProcesso && _vm.idProcesso !== null
        ? _c("app-modal-visualizar-completo", {
            attrs: {
              idProcesso: _vm.idProcesso,
              protocolo: _vm.protocolo,
              numeroProcesso: _vm.numeroProcesso,
              tipo: _vm.tipoProcesso
            },
            on: {
              closeModal: function($event) {
                _vm.showModalVisualizarProcesso = false
              }
            }
          })
        : _vm._e(),
      _vm.showModal
        ? _c(
            "app-modal",
            {
              attrs: {
                modalNova: true,
                closeOutside: true,
                titulo: _vm.titulo,
                width: 980
              },
              on: {
                closeModal: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [
              _c(
                "template",
                { slot: "body" },
                [
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-atualizacao-base",
                      files: _vm.anexos,
                      fileType: ["png", "jpg", "jpeg"]
                    },
                    on: {
                      uploadFile: _vm.uploadFile,
                      removeFile: _vm.removeFile,
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  })
                ],
                1
              ),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        key: "botao-confirma",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.adicionarFotos()
                          }
                        }
                      },
                      [_vm._v("Salvar fotos no processo")]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-edf0ee6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edf0ee6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/CadastrarFotosReurb.vue
// module id = null
// module chunks = 